import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import FoundersSection from "./components/FoundersSection";
import ChaptersSection from "./components/ChaptersSection";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <FoundersSection />
      <ChaptersSection />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default Index;
